import {
  HOLDED_GET_CONTACTS_LIST,
  HOLDED_GET_CONTACTS_LIST_SUCCESS,
  HOLDED_GET_CONTACTS_LIST_ERROR,
  HOLDED_GET_CONTACT_INFO,
  HOLDED_GET_CONTACT_INFO_SUCCESS,
  HOLDED_GET_CONTACT_INFO_ERROR,
  HOLDED_ADD_CONTACT_INFO,
  HOLDED_ADD_CONTACT_INFO_SUCCESS,
  HOLDED_ADD_CONTACT_INFO_ERROR,
  HOLDED_UPDATE_CONTACT_INFO,
  HOLDED_UPDATE_CONTACT_INFO_SUCCESS,
  HOLDED_UPDATE_CONTACT_INFO_ERROR,
  HOLDED_ADD_DOCUMENT_ITEM,
  HOLDED_ADD_DOCUMENT_ITEM_SUCCESS,
  HOLDED_ADD_DOCUMENT_ITEM_ERROR,
  HOLDED_CLEAR_DATA,
} from "../actions";

const INIT_STATE = {
  loading: false,
  contactsList: null,
  contactInfo: null,
  addContactInfo: null,
  updateContactInfo: null,
  addDocumentItem: null,
  error: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //* GET CONTACTS LIST from Holded // ---------------------------------------------------------------------------------------------

    case HOLDED_GET_CONTACTS_LIST:
      return { ...state, loading: true, error: "" };

    case HOLDED_GET_CONTACTS_LIST_SUCCESS:
      console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        contactsList: action.payload,
        error: "",
      };

    case HOLDED_GET_CONTACTS_LIST_ERROR:
      console.log("error", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        contactsList: null,
      };

    //* GET CONTACT INFO from Holded // ---------------------------------------------------------------------------------------------

    case HOLDED_GET_CONTACT_INFO:
      return { ...state, loading: true, error: "" };

    case HOLDED_GET_CONTACT_INFO_SUCCESS:
      console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        contactInfo: action.payload,
        error: "",
      };

    case HOLDED_GET_CONTACT_INFO_ERROR:
      console.log("error", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        contactInfo: null,
      };

    //* ADD CONTACT INFO to Holded // ---------------------------------------------------------------------------------------------

    case HOLDED_ADD_CONTACT_INFO:
      return { ...state, loading: true, error: "" };

    case HOLDED_ADD_CONTACT_INFO_SUCCESS:
      console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        addContactInfo: action.payload,
        error: "",
      };

    case HOLDED_ADD_CONTACT_INFO_ERROR:
      console.log("error", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        addContactInfo: null,
      };

    //* UPDATE CONTACT INFO to Holded // ---------------------------------------------------------------------------------------------

    case HOLDED_UPDATE_CONTACT_INFO:
      return { ...state, loading: true, error: "" };

    case HOLDED_UPDATE_CONTACT_INFO_SUCCESS:
      console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        updateContactInfo: action.payload,
        error: "",
      };

    case HOLDED_UPDATE_CONTACT_INFO_ERROR:
      console.log("error", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        updateContactInfo: null,
      };

    //* ADD DOCUMENT ITEM to Holded // ---------------------------------------------------------------------------------------------

    case HOLDED_ADD_DOCUMENT_ITEM:
      return { ...state, loading: true, error: "" };

    case HOLDED_ADD_DOCUMENT_ITEM_SUCCESS:
      console.log("success", action.payload);

      return {
        ...state,
        loading: false,
        addDocumentItem: action.payload,
        error: "",
      };

    case HOLDED_ADD_DOCUMENT_ITEM_ERROR:
      console.log("error", action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        addDocumentItem: null,
      };

    //* CLEAR DATA in Redux// ---------------------------------------------------------------------------------------------

    case HOLDED_CLEAR_DATA:
      return {
        ...INIT_STATE,
      };

    default:
      return { ...state };
  }
};
